var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"travel-notes-container"},[_c('travel-notes-list'),_c('div',{staticClass:"container"},[_c('promo-cruise'),_c('email-share')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }